<template>
  <div class="w-100">
    <proa-card class="h-100 d-flex flex-column" no-padding>
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading class="group-chat-name" detail>{{ $t('pages.management.basicInformation.billingHistories') }}</proa-heading>
          <div/>
        </div>
      </template>
      <div class="billing-histories-content">
        <div class="table-outer-wrapper">
          <div class="table-inner-scroll-wrapper">
            <table class="table-attributes" align="left">
              <tbody>
                <tr v-for="bill of bills" :key="bill.id">
                  <th>{{ bill.billingAt | moment('YYYY/MM/DD') }}</th>
                  <td class="fixed">{{ bill.billingAmount | currencyJPY }}</td>
                  <td>
                    <router-link :to="{ name: 'showManagementBillingHistories', params: { id: bill.id } }" class="text-link">
                      {{ $t('pages.IndexManagementBillingHistories.billingDetails') }}
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </proa-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Bill from '@/store/models/admin/Bill'

export default {
  name: 'IndexManagementBillingHistories',
  computed: {
    bills: function() {
      return Bill.query().orderBy('billingAt', 'desc').get()
    }
  },
  methods: {
    onClickBackButton: function() {
      this.$router.push({ name: 'management' })
    },
    ...mapActions({
      apiGetBills: 'entities/bills/index'
    })
  },
  created() {
    this.apiGetBills()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.billing-histories-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-outer-wrapper {
    position: relative;
    height: 100%;
  }

  .table-inner-scroll-wrapper {
    position: absolute;
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
  }

  .table-attributes {
    width: 100%;

    tr {
      display: block;
      border-bottom: 1px solid $light-border-color;
      padding: 15px 20px;

      @include mq(md) {
        display: table-row;
        border-bottom: 1px solid $dark-border-color;
        padding: 0;
      }
    }

    th {
      display: block;
      width: 100%;
      padding: 0;
      font-weight: 600;

      @include mq(md) {
        display: table-cell;
        width: 1px;
        white-space: nowrap;
        padding: 20px 30px 20px 20px;
      }
    }

    td {
      display: block;
      width: 100%;
      padding: 0;
      word-break: break-all;
      margin: 10px 0;

      @include mq(md) {
        display: table-cell;
        width: auto;
        padding: 20px 20px 20px 0;
      }

      &.fixed {
        width: 100px !important;
      }
    }
  }
}
</style>
